/****************************************************
 * Module Name:  pendingStoneReceivedReport.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import PendingReport from "../common/pendingReportComponent";
import { Box } from "@mui/material";
import NoPermission from "../common/noPermission";
import Constants from "../../utility/constants";

const PendingStoneReceived = () => {
  const [access, setAccess] = useState(false);

  useEffect(() => {
    checkPermission();
  }, []);

  const checkPermission = () => {
    let allowed = Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.REPORT_LABTEST_PENDINGSTONERECEIVE
    ) !== undefined
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    }
  }

  return (
    <Box>
      {
        access ? <NoPermission /> : (
          <PendingReport status={"REPORT_RECEIVED"} name='Stone' />
        )}
    </Box>
  );
};

export default PendingStoneReceived;
